import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import PercentageDashboardPanel from '../../core/components/PercentageDashboardPanel'
import i18n from '../i18n'

function agencyFilter(restrict) {
    restrict = restrict && ((restrict instanceof Array) && restrict || [restrict]) || []

    return (agency) => {
        if (restrict.length > 0) {
            return !!restrict.find((r) => r.value == agency.value)
        }
        return true
    }
}

class AgencyDashboardPanel extends Component {
    static propTypes = {
    }

    constructor(props) {
        super(props)

        this.state = {
            filteredAgencies: []
        }
    }

    componentWillMount() {
        const {aggregations, query} = this.props

        const filteredAgencies = aggregations.agencies.filter(agencyFilter(query.agency))
        this.setState({filteredAgencies})
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.aggregations != this.props.aggregations
            || nextProps.query != this.props.query) {
            const {aggregations, query} = nextProps

            const filteredAgencies = aggregations.agencies.filter(agencyFilter(query.agency))
            this.setState({filteredAgencies})
        }
    }

    render() {
        const {dispatch, aggregations, query, ...others} = this.props
        const {filteredAgencies} = this.state

        const panelHeader = (title) => (
            <h4>{title}</h4>
        )

        return (
            <PercentageDashboardPanel
                header={panelHeader(i18n.byAgency)}
                display={(m) => m.label}
                identify={(m) => m.count}
                value={filteredAgencies}
                {...others} />
        )
    }
}

AgencyDashboardPanel = connect((state) => ({
	aggregations: state.ticket.aggregations,
    query: state.ticket.query
}))(AgencyDashboardPanel)

export default AgencyDashboardPanel


// WEBPACK FOOTER //
// ./lib/ticket/components/AgencyDashboardPanel.js